import React from 'react'
import { Link } from 'gatsby'
import { AttachMoney, CalendarToday, Bookmark } from '@material-ui/icons'

import SlideOverlay from '../SlideOverlay'

import { Wrapper, SlideLink, CourseBody, SubscribeBtn, ReadBtn } from './styles'

const NewCourseWrapper = props => {
  const readMoreLink = props.readMoreLink || props.link

  return (
    <Wrapper>
      <CourseBody>
        {props.externalLink ? (
          <a href={readMoreLink} target="_blank" rel="noopener noreferrer">
            {props.name}
          </a>
        ) : (
          <Link to={props.link}>{props.name}</Link>
        )}
        <ul>
          <li>
            <CalendarToday />
            <span>
              <b>{props.graduation === 'pos-graduacao ead' || props.graduation === 'pos-graduacao presencial' ? 'Duração mínima' : 'Duração'}: {props.duration} </b>
            </span>
          </li>
          <li>
            <AttachMoney />
            <span>
              Valor da mensalidade:<b> R$ {props.price}</b>
            </span>
          </li>
          {props.specialPrices ? (
            <li>
              <AttachMoney />
              <span>
                <b>Mensalidades com descontos:</b>
                {props.specialPrices.map(price => (
                  <span key={price} style={{ display: 'block' }}>{price} *</span>
                ))}
              </span>
            </li>
          ) : (
            <li>
              <AttachMoney />
              <span>
                Mensalidade com desconto:<b> R$ {props.price_with_discount}</b> *
              </span>
            </li>
          )}
          {props.parcel && (
            <li>
              <Bookmark />
              <span>
                <b>Mensalidades:</b> {props.parcel}
              </span>
            </li>
          )}
          <span style={{ fontSize: 13 }}>
            * {props.discount_percentage ? `${props.discount_percentage}% ` : ''}desconto para pagamento até o vencimento
          </span>
        </ul>
        <div>
          <SubscribeBtn
            href={props.subscribe || 'https://pag.ae/7VUxxu29q/button'}
            target="_blank"
          >
            Matricule-se
          </SubscribeBtn>
          <ReadBtn href={readMoreLink} target="_blank" rel="noopener noreferrer">
            Saiba mais
          </ReadBtn>
        </div>
      </CourseBody>
    </Wrapper>
  )
}

export default NewCourseWrapper
